
import React, { useEffect, useRef, useState } from 'react';
import prevMonIconImg from '../../images/prevMonIcon.png';
import nextMonIconImg from '../../images/nextMonIcon.png';
import DatePicker from 'react-datepicker';
import { registerLocale } from 'react-datepicker';
import ko from 'date-fns/locale/ko';
import moment from 'moment';
import 'moment/locale/ko';
import arrowIconImg from '../../images/datePickerDropdownIcon.png';
import './CustomDatePicker.scss';
import Select from 'react-select';
import incIconImg from '../../images/incIcon.png';
import decIconImg from '../../images/decIcon.png';

registerLocale('ko', ko);

/* ---------------- Custom Header ---------------- */
const CustomHeader = ({
    date,
    changeMonth,
    changeYear,
    decreaseMonth,
    increaseMonth,
}) => {
    const currYear = moment().year();
    const monthDates = [];
    for (let i = 0; i < 5; i++) {
        if (i === 0) {
            for (let j = moment().month(); j >= 0; j--) {
                const dateData = moment([(currYear - i), j]).format('yyyy-M');
                monthDates.push(dateData.toString());
            }
        } else {
            for (let j = 12 - 1; j >= 0; j--) {
                const dateData = moment([(currYear - i), j]).format('yyyy-M');
                monthDates.push(dateData.toString());
            }
        }
    }

    const onChange = e => {
        e.preventDefault();
        changeMonth(moment(e.target.value).month());
        changeYear(moment(e.target.value).year());
    }

    return (
        <div className='customHeader'>
            <button
                aria-label="Previous Month"
                className={"navigation prevBtn"}
                onClick={decreaseMonth}
                disabled={parseInt(moment(date).format('yyyy')) <= parseInt(moment([(currYear - 4), 0]).format('yyyy')) && parseInt(moment(date).format('M')) <= parseInt(moment([(currYear - 4), 0]).format('M'))}
            >
                <img src={prevMonIconImg} alt={"이전 달"} />
            </button>
            <div className='selectBox'>
                <select onChange={onChange} value={moment(date).format('yyyy-M')}>
                    {monthDates.map((item, idx) => {
                        return (
                            <option key={idx} value={item}>{moment(item).format("yyyy - M월")}</option>
                        );
                    })}
                </select>
                <span className='arrowIcon'><img src={arrowIconImg} alt={"드롭다운"} /></span>
            </div>
            <button
                aria-label="Next Month"
                className={"navigation nextBtn"}
                onClick={increaseMonth}
                disabled={parseInt(moment(date).format('yyyy')) >= parseInt(moment().format('yyyy')) && parseInt(moment(date).format('M')) >= parseInt(moment().format('M'))}
            >
                <img src={nextMonIconImg} alt={"다음 달"} />
            </button>
        </div>
    )
};

/* ---------------- Utility: safeFocus ---------------- */
const safeFocus = (ref) => {
    if (!ref) return;
    // small delay to allow any intermediate re-renders to finish
    setTimeout(() => {
        try { ref.current?.focus(); } catch (e) { /* ignore */ }
    }, 0);
};

/* ---------------- Start Picker ---------------- */
export function CustomDatePickerStart({ startDate, setStartDate, endDate, changeDropdown }) {
    const [isOpen, setIsOpen] = useState(false);

    const CustomTimeInput = ({ date, value, onTimeChange, onChange }) => {
        // local temp state for inputs to avoid committing on every keystroke
        const [hour, setHour] = useState(moment(startDate).format('HH'));
        const [minute, setMinute] = useState(moment(startDate).format('mm'));
        const minuteInputRef = useRef(null);

        useEffect(() => {
            setHour(moment(startDate).format('HH'));
            setMinute(moment(startDate).format('mm'));
        }, [startDate]);

        const handleHourChange = (e) => {
            let val = e.target.value;
            if (val.length > 2) val = val.slice(0, 2);
            // 23 초과하면 즉시 23으로 변경
            let num = parseInt(val, 10);
            if (!isNaN(num) && num > 23) {
                num = 23;
                val = "23";
            }
            setHour(val);

            // auto move to minute field on 2 digits WITHOUT committing parent state
            if (val.length === 2) {
                safeFocus(minuteInputRef);
            }
        };

        const normalizeMinute = (raw) => {
            let m = parseInt(raw, 10);
            if (isNaN(m) || m < 0) m = 0;
            else if (m > 59) m = 59;
            return m;
        };

        const handleMinuteChange = (e) => {
            let val = e.target.value;
            if (val.length > 2) val = val.slice(0, 2);
            setMinute(val);

            // 2자리 다 채워졌을 때 바로 commit
            if (val.length === 2) {
                const m = normalizeMinute(val);
                const h = parseInt(hour, 10);

                setMinute(String(m).padStart(2, '0'));
                commitTimeToParent(h, m);
            }
        };


        // const handleMinuteChange = (e) => {
        //     let val = e.target.value;
        //     if (val.length > 2) val = val.slice(0, 2);
        //     setMinute(val);
        // };

        const handleFocus = (e) => e.target.select();

        const commitTimeToParent = (h, m) => {
            // build new date based on current startDate but with supplied h/m
            const newDate = new Date(startDate);
            if (typeof h === 'string') h = parseInt(h, 10);
            if (typeof m === 'string') m = parseInt(m, 10);
            if (isNaN(h) || h < 0) h = 0;
            if (h > 23) h = 23;
            if (isNaN(m) || m < 0) m = 0;
            if (m > 59) m = 59;
            newDate.setHours(h);
            newDate.setMinutes(m);
            setStartDate(newDate);
            console.log('Committed time to parent:', newDate);
        };

        const handleHourBlur = (e) => {
            // if user is moving to minute input, don't commit here (minute will commit)
            if (e.relatedTarget === minuteInputRef.current) return;

            let h = parseInt(e.target.value, 10);
            if (isNaN(h) || h < 0) h = 0;
            else if (h > 23) h = 23;
            setHour(String(h).padStart(2,'0'));
            // commit with existing minute value
            setTimeout(() => {
                console.log('Hour blur commit:', h, minute);
                commitTimeToParent(h, parseInt(minute, 10));
                
            }, 0);
        };

        const handleMinuteBlur = (e) => {
            let m = parseInt(e.target.value, 10);
            if (isNaN(m) || m < 0) m = 0;
            else if (m > 59) m = 59;
            setMinute(String(m).padStart(2,'0'));
            // when minute blur happens, commit both hour and minute
            setTimeout(() => {
            commitTimeToParent(parseInt(hour, 10), m);
            }, 0);
        };

        const handleHourInc = () => {
            const newHour = (parseInt(hour, 10) + 1) % 24; // 23 다음은 0
            setHour(String(newHour).padStart(2, '0'));
            commitTimeToParent(newHour, parseInt(minute, 10));
        };

        const handleHourDec = () => {
            const newHour = (parseInt(hour, 10) - 1 + 24) % 24; // 0 이전은 23
            setHour(String(newHour).padStart(2, '0'));
            commitTimeToParent(newHour, parseInt(minute, 10));
        };

        const handleMinuteInc = () => {
            const newMinute = (parseInt(minute, 10) + 1) % 60; // 59 다음은 0
            setMinute(String(newMinute).padStart(2, '0'));
            commitTimeToParent(parseInt(hour, 10), newMinute);
        };
        
        const handleMinuteDec = () => {
            const newMinute = (parseInt(minute, 10) - 1 + 60) % 60; // 0 이전은 59
            setMinute(String(newMinute).padStart(2, '0'));
            commitTimeToParent(parseInt(hour, 10), newMinute);
        };

        return (
            <div className='timeNSubmit'>
                <div className='timeInputArea'>
                    <div className='hourInputArea inputArea'>
                        <input
                            className='hourInput timeInput'
                            type='number'
                            value={hour}
                            onChange={handleHourChange}
                            onFocus={handleFocus}
                            onBlur={handleHourBlur}
                        />
                        <div className='btnsArea'>
                            <button name='hour' id='hourInc' onClick={handleHourInc}><img src={incIconImg} alt='시간-위' /></button>
                            <button name='hour' id='hourDec' onClick={handleHourDec}><img src={decIconImg} alt='시간-아래' /></button>
                        </div>
                    </div>
                    <span>:</span>
                    <div className='minuteInputArea inputArea'>
                        <input
                            ref={minuteInputRef}
                            className='minuteInput timeInput'
                            type='number'
                            value={minute}
                            onChange={handleMinuteChange}
                            onFocus={handleFocus}
                            onBlur={handleMinuteBlur}
                        />
                        <div className='btnsArea'>
                            <button name='minute' id='minuteInc' onClick={handleMinuteInc}><img src={incIconImg} alt='분-위' /></button>
                            <button name='minute' id='minuteDec' onClick={handleMinuteDec}><img src={decIconImg} alt='분-아래' /></button>
                        </div>
                    </div>
                </div>
            </div>
        )
    };

    const CustomInput = React.forwardRef(({ value, onClick }, ref) => {
        return (
            <React.Fragment>
                <input type='text' onClick={e => {
                    onClick(e);
                    changeDropdown?.();
                    setIsOpen(true);
                }} value={moment(startDate).format('yyyy-MM-DD (dd) H:mm').toLocaleString('Ko')} ref={ref} readOnly />
                <input type='text' value={value} hidden={true} readOnly />
            </React.Fragment>
        );
    });

    return (
        <DatePicker
            open={isOpen}
            // onClickOutside={() => { setIsOpen(false) }}
            onClickOutside={() => {
                // 현재 포커스된 input blur → 각 input의 onBlur에서 commit 실행됨
                if (document.activeElement && typeof document.activeElement.blur === 'function') {
                    document.activeElement.blur();
                }
                setIsOpen(false);
            }}
            selected={startDate}
            value={startDate}
            onChange={(date) => setStartDate(date)}
            shouldCloseOnSelect={false}
            locale={'ko'}
            showTimeInput
            timeInputLabel=''
            renderCustomHeader={CustomHeader}
            customTimeInput={<CustomTimeInput />}
            dateFormat={'yyyy-MM-dd (E) H:mm'}
            selectsStart
            startDate={startDate}
            endDate={endDate}
            customInput={<CustomInput />}
            minDate={new Date(moment([(moment().year() - 4), 0, 1]))}
            maxDate={endDate}
        />
    );
}

/* ---------------- End Picker ---------------- */
export function CustomDatePickerEnd({ startDate, endDate, setEndDate, changeDropdown }) {
    const [isOpen, setIsOpen] = useState(false);

    const CustomTimeInput = ({ date, value, onTimeChange, onChange }) => {
        const [hour, setHour] = useState(moment(endDate).format('HH'));
        const [minute, setMinute] = useState(moment(endDate).format('mm'));
        const minuteInputRef = useRef(null);

        useEffect(() => {
            setHour(moment(endDate).format('HH'));
            setMinute(moment(endDate).format('mm'));
        }, [endDate]);

        const handleHourChange = (e) => {
            let val = e.target.value;
            if (val.length > 2) val = val.slice(0, 2);
            let num = parseInt(val, 10);
            if (!isNaN(num) && num > 23) {
                num = 23;
                val = "23";
            }
            setHour(val);
            if (val.length === 2) safeFocus(minuteInputRef);
        };

        const normalizeMinute = (raw) => {
            let m = parseInt(raw, 10);
            if (isNaN(m) || m < 0) m = 0;
            else if (m > 59) m = 59;
            return m;
        };

        const handleMinuteChange = (e) => {
            let val = e.target.value;
            if (val.length > 2) val = val.slice(0, 2);
            setMinute(val);

            // 2자리 다 채워졌을 때 바로 commit
            if (val.length === 2) {
                const m = normalizeMinute(val);
                const h = parseInt(hour, 10);

                setMinute(String(m).padStart(2, '0'));
                commitTimeToParent(h, m);
            }
        };

        // const handleMinuteChange = (e) => {
        //     let val = e.target.value;
        //     if (val.length > 2) val = val.slice(0, 2);
        //     setMinute(val);
        // };

        const handleFocus = (e) => e.target.select();

        const commitTimeToParent = (h, m) => {
            const newDate = new Date(endDate);
            if (typeof h === 'string') h = parseInt(h, 10);
            if (typeof m === 'string') m = parseInt(m, 10);
            if (isNaN(h) || h < 0) h = 0;
            if (h > 23) h = 23;
            if (isNaN(m) || m < 0) m = 0;
            if (m > 59) m = 59;
            newDate.setHours(h);
            newDate.setMinutes(m);
            setEndDate(newDate);
        };

        const handleHourBlur = (e) => {
            if (e.relatedTarget === minuteInputRef.current) return;
            let h = parseInt(e.target.value, 10);
            if (isNaN(h) || h < 0) h = 0;
            else if (h > 23) h = 23;
            setHour(String(h).padStart(2,'0'));
            commitTimeToParent(h, parseInt(minute, 10));
        };

        const handleMinuteBlur = (e) => {
            let m = parseInt(e.target.value, 10);
            if (isNaN(m) || m < 0) m = 0;
            else if (m > 59) m = 59;
            setMinute(String(m).padStart(2,'0'));
            commitTimeToParent(parseInt(hour, 10), m);
        };

        const handleHourInc = () => {
            const newHour = (parseInt(hour, 10) + 1) % 24; // 23 다음은 0
            setHour(String(newHour).padStart(2, '0'));
            commitTimeToParent(newHour, parseInt(minute, 10));
        };

        const handleHourDec = () => {
            const newHour = (parseInt(hour, 10) - 1 + 24) % 24; // 0 이전은 23
            setHour(String(newHour).padStart(2, '0'));
            commitTimeToParent(newHour, parseInt(minute, 10));
        };

        const handleMinuteInc = () => {
            const newMinute = (parseInt(minute, 10) + 1) % 60; // 59 다음은 0
            setMinute(String(newMinute).padStart(2, '0'));
            commitTimeToParent(parseInt(hour, 10), newMinute);
        };
        
        const handleMinuteDec = () => {
            const newMinute = (parseInt(minute, 10) - 1 + 60) % 60; // 0 이전은 59
            setMinute(String(newMinute).padStart(2, '0'));
            commitTimeToParent(parseInt(hour, 10), newMinute);
        };

        return (
            <div className='timeNSubmit'>
                <div className='timeInputArea'>
                    <div className='hourInputArea inputArea'>
                        <input
                            className='hourInput timeInput'
                            type='number'
                            value={hour}
                            onChange={handleHourChange}
                            onFocus={handleFocus}
                            onBlur={handleHourBlur}
                        />
                        <div className='btnsArea'>
                            <button name='hour' id='hourInc' onClick={handleHourInc}><img src={incIconImg} alt='시간-위' /></button>
                            <button name='hour' id='hourDec' onClick={handleHourDec}><img src={decIconImg} alt='시간-아래' /></button>
                        </div>
                    </div>
                    <span>:</span>
                    <div className='minuteInputArea inputArea'>
                        <input
                            ref={minuteInputRef}
                            className='minuteInput timeInput'
                            type='number'
                            value={minute}
                            onChange={handleMinuteChange}
                            onFocus={handleFocus}
                            onBlur={handleMinuteBlur}
                        />
                        <div className='btnsArea'>
                            <button name='minute' id='minuteInc' onClick={handleMinuteInc}><img src={incIconImg} alt='분-위' /></button>
                            <button name='minute' id='minuteDec' onClick={handleMinuteDec}><img src={decIconImg} alt='분-아래' /></button>
                        </div>
                    </div>
                </div>
            </div>
        )
    };

    const CustomInput = React.forwardRef(({ value, onClick }, ref) => {
        return (
            <React.Fragment>
                <input type='text' onClick={e => {
                    onClick(e);
                    changeDropdown?.();
                    setIsOpen(true);
                }} value={moment(endDate).format('yyyy-MM-DD (dd) H:mm').toLocaleString('Ko')} ref={ref} readOnly />
                <input type='text' value={value} hidden={true} readOnly />
            </React.Fragment>
        );
    });
    return (
        <DatePicker
            open={isOpen}
            // onClickOutside={() => { setIsOpen(false) }}
            onClickOutside={() => {
                    if (document.activeElement && typeof document.activeElement.blur === 'function') {
                    document.activeElement.blur();
                }
                setIsOpen(false);
            }}
            selected={endDate}
            value={endDate}
            onChange={(date) => setEndDate(date)}
            shouldCloseOnSelect={false}
            locale={'ko'}
            showTimeInput
            timeInputLabel=''
            renderCustomHeader={CustomHeader}
            customTimeInput={<CustomTimeInput />}
            dateFormat={'yyyy-MM-dd (E) H:mm'}
            selectsEnd
            startDate={startDate}
            endDate={endDate}
            customInput={<CustomInput />}
            minDate={startDate}
            maxDate={new Date()}
        />
    );
}

/* ---------------- Generic Custom DateTime Picker ---------------- */
export function CustomDatePicker({ data, setData, isDisabled = false }) {
    const [isOpen, setIsOpen] = useState(false);

    const CustomTimeInput = ({ date, value, onTimeChange, onChange }) => {
        const [hour, setHour] = useState(moment(data).format('HH'));
        const [minute, setMinute] = useState(moment(data).format('mm'));
        const [second, setSecond] = useState(moment(data).format('ss'));
        const minuteInputRef = useRef(null);
        const secondInputRef = useRef(null);

        useEffect(() => {
            setHour(moment(data).format('HH'));
            setMinute(moment(data).format('mm'));
            setSecond(moment(data).format('ss'));
        }, [data]);

        const handleHourChange = (e) => {
            let val = e.target.value;
            if (val.length > 2) val = val.slice(0, 2);
            setHour(val);
            if (val.length === 2) safeFocus(minuteInputRef);
        };

        const handleMinuteChange = (e) => {
            let val = e.target.value;
            if (val.length > 2) val = val.slice(0, 2);
            setMinute(val);
            if (val.length === 2) safeFocus(secondInputRef);
        };

        const handleSecondChange = (e) => {
            let val = e.target.value;
            if (val.length > 2) val = val.slice(0, 2);
            setSecond(val);
        };

        const handleFocus = (e) => e.target.select();

        const commitTimeToParent = (h, m, s) => {
            const newDate = new Date(data);
            if (typeof h === 'string') h = parseInt(h, 10);
            if (typeof m === 'string') m = parseInt(m, 10);
            if (typeof s === 'string') s = parseInt(s, 10);
            if (isNaN(h) || h < 0) h = 0;
            if (h > 23) h = 23;
            if (isNaN(m) || m < 0) m = 0;
            if (m > 59) m = 59;
            if (isNaN(s) || s < 0) s = 0;
            if (s > 59) s = 59;
            newDate.setHours(h);
            newDate.setMinutes(m);
            newDate.setSeconds(s);
            setData(newDate);
        };

        const handleHourBlur = (e) => {
            if (e.relatedTarget === minuteInputRef.current) return;
            let h = parseInt(e.target.value, 10);
            if (isNaN(h) || h < 0) h = 0;
            else if (h > 23) h = 23;
            setHour(String(h).padStart(2,'0'));
            commitTimeToParent(h, parseInt(minute, 10), parseInt(second, 10));
        };

        const handleMinuteBlur = (e) => {
            if (e.relatedTarget === secondInputRef.current) return;
            let m = parseInt(e.target.value, 10);
            if (isNaN(m) || m < 0) m = 0;
            else if (m > 59) m = 59;
            setMinute(String(m).padStart(2,'0'));
            commitTimeToParent(parseInt(hour, 10), m, parseInt(second, 10));
        };

        const handleSecondBlur = (e) => {
            let s = parseInt(e.target.value, 10);
            if (isNaN(s) || s < 0) s = 0;
            else if (s > 59) s = 59;
            setSecond(String(s).padStart(2,'0'));
            commitTimeToParent(parseInt(hour, 10), parseInt(minute, 10), s);
        };

        const handleHourInc = () => {
            const newHour = (parseInt(hour, 10) + 1) % 24; // 23 다음은 0
            setHour(String(newHour).padStart(2, '0'));
            commitTimeToParent(newHour, parseInt(minute, 10), parseInt(second, 10));
        };

        const handleHourDec = () => {
            const newHour = (parseInt(hour, 10) - 1 + 24) % 24; // 0 이전은 23
            setHour(String(newHour).padStart(2, '0'));
            commitTimeToParent(newHour, parseInt(minute, 10), parseInt(second, 10));
        };

        const handleMinuteInc = () => {
            const newMinute = (parseInt(minute, 10) + 1) % 60; // 59 다음은 0
            setMinute(String(newMinute).padStart(2, '0'));
            commitTimeToParent(parseInt(hour, 10), newMinute, parseInt(second, 10));
        };
        
        const handleMinuteDec = () => {
            const newMinute = (parseInt(minute, 10) - 1 + 60) % 60; // 0 이전은 59
            setMinute(String(newMinute).padStart(2, '0'));
            commitTimeToParent(parseInt(hour, 10), newMinute, parseInt(second, 10));
        };

        const handleSecondInc = () => {
            const newSecond = (parseInt(second, 10) + 1) % 60; // 59 다음은 0
            setSecond(String(newSecond).padStart(2, '0'));
            commitTimeToParent(parseInt(hour, 10), parseInt(minute, 10), newSecond);
        };


        const handleSecondDec = () => {
            const newSecond = (parseInt(second, 10) - 1 + 60) % 60; // 0 이전은 59
            setSecond(String(newSecond).padStart(2, '0'));
            commitTimeToParent(parseInt(hour, 10), parseInt(minute, 10), newSecond);
        };   

        return (
            <div className='timeNSubmit'>
                <div className='timeInputArea'>
                    <div className='hourInputArea inputArea'>
                        <input
                            className='hourInput timeInput'
                            type='number'
                            value={hour}
                            onChange={handleHourChange}
                            onFocus={handleFocus}
                            onBlur={handleHourBlur}
                        />
                        <div className='btnsArea'>
                            <button name='hour' id='hourInc' onClick={handleHourInc}><img src={incIconImg} alt='시간-위' /></button>
                            <button name='hour' id='hourDec' onClick={handleHourDec}><img src={decIconImg} alt='시간-아래' /></button>
                        </div>

                    </div>
                    <span>:</span>
                    <div className='minuteInputArea inputArea'>
                        <input
                            ref={minuteInputRef}
                            className='minuteInput timeInput'
                            type='number'
                            value={minute}
                            onChange={handleMinuteChange}
                            onFocus={handleFocus}
                            onBlur={handleMinuteBlur}
                        />
                        <div className='btnsArea'>
                            <button name='minute' id='minuteInc' onClick={handleMinuteInc}><img src={incIconImg} alt='분-위' /></button>
                            <button name='minute' id='minuteDec' onClick={handleMinuteDec}><img src={decIconImg} alt='분-아래' /></button>
                        </div>
                    </div>
                    <span>:</span>
                    <div className='secondInputArea inputArea'>
                        <input
                            ref={secondInputRef}
                            className='secondInput timeInput'
                            type='number'
                            value={second}
                            onChange={handleSecondChange}
                            onFocus={handleFocus}
                            onBlur={handleSecondBlur}
                        />
                        <div className='btnsArea'>
                            <button name='second' id='secondInc' onClick={handleSecondInc}><img src={incIconImg} alt='초-위' /></button>
                            <button name='second' id='secondDec' onClick={handleSecondDec}><img src={decIconImg} alt='초-아래' /></button>
                        </div>
                    </div>
                </div>
            </div>
        )
    };

    const CustomInput = React.forwardRef(({ value, onClick }, ref) => {
        return (
            <React.Fragment>
                <input type='text' onClick={e => {
                    if (!isDisabled) {
                        onClick(e);
                        setIsOpen(true);
                    }
                }} value={moment(data).format('yyyy-MM-DD H:mm:ss').toLocaleString('Ko')} ref={ref} readOnly />
                <input type='text' value={value} hidden={true} readOnly />
            </React.Fragment>
        );
    });
    return (
        <div className='customDatePickerArea'>
            <DatePicker
                open={isOpen}
                // onClickOutside={() => { setIsOpen(false) }}
                onClickOutside={() => {
                    if (document.activeElement && typeof document.activeElement.blur === 'function') {
                    document.activeElement.blur();
                }
                setIsOpen(false);
            }}
                selected={data}
                value={data}
                onChange={(date) => setData(date)}
                shouldCloseOnSelect={false}
                locale={'ko'}
                showTimeInput
                timeInputLabel=''
                renderCustomHeader={CustomHeader}
                customTimeInput={<CustomTimeInput />}
                dateFormat={'yyyy-MM-dd (E) H:mm:ss'}
                selectsEnd
                customInput={<CustomInput />}
                minDate={new Date(moment([(moment().year() - 4), 0, 1]))}
                maxDate={new Date()}
            />
        </div>
    );
}
